import React from 'react';

interface IActionOptionProps {
  action: () => void;
  icon?: JSX.Element;
  label: string;
}

const ActionOption = ({
  action,
  label,
  icon,
}: IActionOptionProps): JSX.Element => {
  return (
    <div onClick={() => action()} className="box-action-map-item">
      {icon || null}
      <span>{label}</span>
    </div>
  );
};

export default ActionOption;
